<template>
  <div class="login-container">
    <div class="login-form">
      <b-row class="mb-3" align-v="center">
        <b-col md="12" class="text-center">
          <b-img :src="mantrazLogo" alt="Mantraz Logo" class="login-logo"></b-img>
        </b-col>
      </b-row>
      <div class="login-form-card">
        <h3 class="mb-3 text-center">Update Password</h3>
        <p class="text-center mx-auto login-subtitle">Enter your new password to update your account.</p>
        <div class="form-container">
          <update-password-form @onSuccess="onSuccess" @onFailure="onFailure" />
        </div>
      </div>
    </div>
    <div class="login-image">
      <div v-if="isLoadingVideo" class="video-loading-spinner">
        <b-spinner label="Loading..." type="grow"></b-spinner>
        <p class="mt-2 text-white">Loading...</p>
      </div>
      <video :src="currentVideoSource" autoplay loop muted playsinline
        :class="{ 'background-video': true, 'video-hidden': isLoadingVideo }" @loadeddata="onVideoLoaded">
      </video>
    </div>

    <!-- Modal -->
    <b-modal id="updatePasswordModal" title="Notification" ok-title="OK" @hide="resetModal">
      <p>{{ modalText }}</p>
    </b-modal>
  </div>
</template>

<script>
import gmailIcon from '@/assets/images/gmail.png';
import UpdatePasswordForm from '@/components/auth/UpdatePasswordForm';
import mantrazImage from '@/assets/images/Mantraz.png';
import AuthSvc from '@/services/AuthSvc';
import video720p from '@/assets/video/Mantraz_Web_720p.webm';
import video1080p from '@/assets/video/Mantraz_Web_1080p.webm';

export default {
  name: 'UpdatePassword',
  components: {
    UpdatePasswordForm,
  },
  data() {
    return {
      displayLoginForm: process.env.VUE_APP_ENABLE_FORM_LOGIN,
      gmailIconURL: gmailIcon,
      mantrazLogo: mantrazImage,
      currentVideoSource: '',
      video720pURL: video720p,
      video1080pURL: video1080p,
      isLoadingVideo: true,
      modalText: 'You will be redirectet to login page',
    };
  },
  async mounted() {
    const userStatus = await this.getUserStatus();
    if (userStatus?.username) {
      await this.$router.push({ name: 'CompanyActiveSelection' });
    }

    this.setVideoSource();
    window.addEventListener('resize', this.setVideoSource);
  },
  methods: {
    setVideoSource() {
      if (window.innerWidth >= 1080) {
        this.currentVideoSource = this.video1080pURL;
      } else {
        this.currentVideoSource = this.video720pURL;
      }
    },
    async getUserStatus() {
      try {
        const response = await AuthSvc.getUserStatus();
        return response.data;
      } catch (error) {
        console.error('Error fetching user status:', error);
        return null;
      }
    },
    onVideoLoaded() {
      this.isLoadingVideo = false;
    },
    onSuccess() {
      this.showModal('Password updated successfully. You will be redirectet to login page.');

      setTimeout(() => {
        this.$router.push({ name: 'Login' });
      }, 5000);
    },
    async onFailure(err) {
      console.log('login failure', err);
    },
    showModal(txt) {
      this.modalText = txt;
      this.$bvModal.show('updatePasswordModal'); // Menampilkan modal
    },
    resetModal() {
      this.$bvModal.hide('updatePasswordModal'); // Menampilkan modal
    },
  },
};
</script>

<style scoped>
/* Gaya yang diubah dan ditambahkan */
.login-form-card {
  padding: 35px;
  border-radius: 10px;
  /* Menggunakan box-shadow yang lebih modern dan lembut */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  max-width: 400px;
  margin: 0 auto;
}

.login-form-card h3 {
  font-weight: 600;
  color: #343a40;
}

.login-subtitle {
  font-size: 14px;
  /* Warna disesuaikan agar konsisten */
  color: #6c757d;
}

.form-container >>> .btn-primary {
  background: linear-gradient(to right, #ff69b4, #ff3d9a) !important;
  border: none !important;
  color: white !important;
  padding: 10px 20px !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  transition: opacity 0.3s ease !important;
  width: 100%;
}

.form-container >>> .btn-primary:hover {
  opacity: 0.9;
}

.form-container >>> .btn-primary:disabled {
  background: #cccccc !important;
  cursor: not-allowed;
}

/* Gaya yang sudah ada (tidak diubah) */
.login-logo {
  width: 200px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 0;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.login-container {
  min-height: 100vh;
  display: flex;
}

.login-form {
  flex: 3;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #e0e0e0;
  background-color: #f8f9fa; /* Latar belakang form agar sedikit berbeda */
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.login-image {
  flex: 7;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333;
}

.video-hidden {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s, visibility 0.5s;
}

.video-loading-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #e0e0e0;
  z-index: 1;
}

.login-image .background-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 1;
  transition: opacity 0.5s;
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .login-image {
    display: none;
  }

  .login-form {
    border-right: none;
    padding: 20px;
    max-height: 100vh;
  }
}
</style>
